import React, { useEffect, useState } from "react";
import { Subheadline } from "@quintype/arrow";
import TruncatedText from "../../atoms/truncated-text";
import get from "lodash/get";

import HeroImage from "./hero-image";
import AuthorAndTimeStamp from "./author-and-timestamp";
import EmbedElementCard, { getPrimaryEmbed } from "./embed-element";
import LiveIcon from "../../atoms/icons/live-icon";
import { getHeroOverrideElement } from "../../helper/utils";


import "./story-header.m.css";

const StoryHeader = ({
  story,
  isPodCast,
  showHeroImage,
  isSponsoredStory,
  isLiveBlog,
  isEmbed,
  closeLiveBlog,
  isBrandspotClientStory
}) => {
  const isClosed = get(story, ["metadata", "is-closed"], false);
  const customKicker = get(story, ["metadata", "story-attributes", "customkicker"], "");
  const heroImageOverride = story?.["metadata"]?.["story-attributes"]?.["heroimageoverride"]?.[0] === "true";
  const embedElement = getPrimaryEmbed(story);
  const isPodcastType = story["story-template"] === "podcast";
  const isBrandspotNoAdStory = story["story-template"] === "brandspot-with-no-ad";

  const { component: RenderHeroComponent, elementId: heroElementId } =
  getHeroOverrideElement({
    story,
    heroImageOverride,
    showHeroImage,
  });

  return (
    <div styleName="wrapper">
      {isPodCast && <EmbedElementCard story={story} />}
      {customKicker.length > 0 ? (
        <div styleName={`custom-kicker ${isPodcastType ? "for-podcast" : ""}`}>{customKicker}</div>
      ) : null}
      <div styleName={isLiveBlog && !closeLiveBlog ? "live-blog-header-h1-wrapper" : "header-h1-wrapper"}>
        {isLiveBlog && !isClosed && !closeLiveBlog && <LiveIcon storyHeader={true} />}
        <h1>{story.headline}</h1>
      </div>
      {isLiveBlog && !closeLiveBlog ? (
        <TruncatedText story={story} />
      ) : (
        <Subheadline lineClamp={10} story={story} clazzName="sub-headline" />
      )}
      <div
        className={`author-resizer-wrapper ${
          !isSponsoredStory && !isBrandspotClientStory && !isBrandspotNoAdStory ? "author-resizer-height" : ""
        }`}
        id="author-resizer-wrapper"
      >
        <AuthorAndTimeStamp
          story={story}
          isSponsoredStory={isSponsoredStory}
          isBrandspotClientStory={isBrandspotClientStory}
          isBrandspotNoAdStory={isBrandspotNoAdStory}
        />
      </div>
      {isEmbed && embedElement ? <EmbedElementCard story={story} /> : null}
      {RenderHeroComponent}
    </div>
  );
};

StoryHeader.defaultProps = {
  isPodcast: false,
  isSponsoredStory: false,
  isBrandspotClientStory: false,
  showHeroImage: true,
  isLiveBlog: false,
  isEmbed: false
};

export default StoryHeader;
